import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../app/theme";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  logo: {
    width: "66px",
    [theme.breakpoints.up("sm")]: {
      width: "106px"
    }
  },
  colorOrange: {
    color: color.orange
  },
  heroSection: {
    "fontFamily": "Axiforma, serif, sans-serf !important",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "100%",
    "color": "#f9f9f9",
    "& .check-icon": {
      width: "143px",
      height: "143px",
      [theme.breakpoints.down("sm")]: {
        "& img": {
          width: "72px",
          height: "72px"
        },
        "width": "72px",
        "height": "72px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "32px",
      paddingRight: "32px"
    }
  },
  gradient: { backgroundImage: "linear-gradient(to bottom, rgba(0, 0, 0, 0.78) , rgba(0, 0, 0, 0.31))" },
  fontSizeSm: {
    fontSize: "10px !important"
  },
  slider: {
    "& .slick-slider": {
      "width": "100%",
      "height": "100%",
      "& .slick-list": {
        "width": "100%",
        "height": "100%",
        "& .slick-track": { "height": "100%", "& div": { height: "100%" } }
      }
    },
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  },
  btnSubscription: {
    padding: 0,
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  }
}));
